import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { mergeMap, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";
import { getBaseUrl } from "frame";
import fromTypes from "../actions/types";

import { onConfirmationFulfilled, onConfirmationFailed } from "../actions";

const confirmationEffect = (action$, state$) =>
	action$.pipe(
		ofType(fromTypes.AUTHORISATION_CONFIRMATION),
		mergeMap(({ payload }) => {
			const url = `${getBaseUrl()}/api/confirm${payload}`;
			console.log("[ConfirmationEffect] action received — POST:", url);
			return ajax.post(url).pipe(
				mergeMap((ajaxResponse) => {
					console.log("[ConfirmationEffect] success — status:", ajaxResponse.status, "| response:", ajaxResponse.response);
					const message = ajaxResponse.response
						?? ajaxResponse.xhr?.responseText?.replace(/^"|"$/g, "")
						?? "Your account has been successfully confirmed.";
					return of(onConfirmationFulfilled(message));
				}),
				catchError((error) => {
					const message = typeof error?.response === "string"
						? error.response
						: error?.message || "Confirmation failed. Please try again.";
					console.error("[ConfirmationEffect] error — status:", error?.status, "| message:", message, "| raw error:", error);
					return of(onConfirmationFailed(message));
				})
			);
		})
	);

export default confirmationEffect;
